var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFolderPhotoGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 150,
    viewBox: "0 0 150 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M96.1802 135.15H3.68018L15.0002 80.09C15.2304 78.7907 15.9028 77.6111 16.9034 76.7509C17.9039 75.8906 19.1711 75.4028 20.4902 75.37H102.88C103.578 75.4005 104.26 75.5853 104.878 75.9109C105.496 76.2365 106.035 76.695 106.454 77.2533C106.874 77.8117 107.165 78.4561 107.306 79.1402C107.447 79.8243 107.435 80.5311 107.27 81.21L96.1802 135.15Z",
    fill: "#CDD9E2",
    stroke: "#CDD9E2",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M122.98 75.23L96.9204 63.08L113.97 53.72L116.36 63.56L120.49 61.52L122.98 75.23Z",
    fill: "#B4C5D0",
    stroke: "#B4C5D0",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M131.87 56.81C131.598 57.3968 131.157 57.8896 130.604 58.2258C130.051 58.5621 129.411 58.7267 128.764 58.699C128.118 58.6712 127.494 58.4522 126.972 58.0698C126.45 57.6874 126.053 57.1587 125.832 56.5506C125.611 55.9426 125.575 55.2825 125.729 54.654C125.883 54.0255 126.22 53.4568 126.697 53.0199C127.174 52.583 127.77 52.2975 128.41 52.1996C129.05 52.1017 129.704 52.1958 130.29 52.47C131.073 52.8389 131.678 53.5019 131.974 54.3148C132.27 55.1276 132.232 56.0244 131.87 56.81Z",
    fill: "#B4C5D0",
    stroke: "#B4C5D0",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M94.5302 30.95H81.7002V18.11L94.5302 30.95Z",
    fill: "#B4C5D0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M94.5302 30.95H81.7002V18.11L94.5302 30.95Z",
    stroke: "#B4C5D0",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M81.0903 70.68L102.44 24.89L148.68 46.45L127.12 92.68L111.87 85.57",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M38.5703 71.0699V22.7499C38.569 22.2816 38.6601 21.8176 38.8384 21.3845C39.0168 20.9514 39.2788 20.5578 39.6095 20.2262C39.9402 19.8945 40.3331 19.6314 40.7657 19.4519C41.1982 19.2723 41.662 19.1799 42.1303 19.1799H82.0603",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M49.2603 42.6699H81.2303",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M49.2603 51.11H77.4703",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M49.2603 59.5499H81.2303",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M49.2603 67.98H69.6703",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M3.68018 135.15V54.38H27.8602L31.9202 62.25H37.1702",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolderPhotoGrey);
export default __webpack_public_path__ + "static/media/folder_photo_grey.f88d72fd9428c4f4f9f27d78935f4972.svg";
export { ForwardRef as ReactComponent };